export default "__VITE_ASSET__MYrI1cu9__"